module.exports = __webpack_public_path__ + "static/media/logo.941aa89a.png";